export const formatacaoDeValores = {
    methods: {
        formatarValorMonetarioParaExibicao(valor) {
            return this.separarMilharComPonto(parseFloat(valor).toFixed(2).toString().replace('.', ','));
        },
        separarMilharComPonto(valor) {
            return valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        formatarCpf(texto) {
            texto = texto.replace( /\D/g , "");
                        
            if (texto.length==11){
                texto = texto.replace( /(\d{3})(\d)/ , "$1.$2");
                texto = texto.replace( /(\d{3})(\d)/ , "$1.$2");
                texto = texto.replace( /(\d{3})(\d{1,2})$/ , "$1-$2");

                return texto;
            }

            return "";
        }
    }
}